import { render } from "./SvgIcon.vue?vue&type=template&id=66b7428b"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=66b7428b&lang=css"
script.render = render

export default script